<div
  class="form-group"
  [ngClass]="{
    'form-group--prefix': prefix && prefix !== '',
    'form-group--suffix': (suffix && suffix !== '') || clearInput || type === inputType.PASSWORD,
  }"
  *ngIf="control && type !== inputType.CHECKBOX"
>
  <label systemLabel [for]="forLabel" class="form-group-label" *ngIf="type !== inputType.SIGNATURE">
    {{ label | translate }}
    <span *ngIf="isRequired" class="form-group-label__required-indicator">*</span>
  </label>
  <div class="form-group-input-icons">
    <!-- Prefix icon -->
    <app-system-icon
      [iconName]="prefix"
      class="form-group-input-icons__prefix"
      *ngIf="prefix && prefix !== ''"
    ></app-system-icon>
    <!-- INPUT !== CHECKBOX AND !== SELECT AND !== RADIO -->
    <ng-container
      *ngIf="
        type !== inputType.SELECT &&
        type !== inputType.FILE &&
        type !== inputType.RADIO &&
        type !== inputType.CHECKBOX &&
        type !== inputType.TEXTAREA &&
        type !== inputType.SIGNATURE
      "
    >
      <input
        [type]="type !== inputType.PASSWORD ? type : type === inputType.PASSWORD && !showPassword ? 'password' : 'text'"
        [formControl]="control"
        systemInputText
        [placeholder]="placeholder"
        class="form-group__input block w-full p-2.5 form-group-input-icons__input"
        [ngClass]="{
          'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500':
            control.invalid && submitting,
          'input-disabled': control.disabled,
          'form-group-input-icons__input--prefix': prefix && prefix !== '',
          'form-group-input-icons__input--suffix':
            (suffix && suffix !== '') || (clearInput && !inputsShowClearOption.includes(type)),
        }"
        [(ngModel)]="inputValue[0]"
        (ngModelChange)="temporalSaveData()"
      />
    </ng-container>
    <!-- TEXTAREA -->
    <ng-container *ngIf="type === inputType.TEXTAREA">
      <textarea
        [formControl]="control"
        rows="4"
        systemInputText
        [placeholder]="placeholder"
        class="form-group__input block w-full p-2.5 form-group-input-icons__input"
        [ngClass]="{
          'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500':
            control.invalid && submitting,
          'form-group-input-icons__input--suffix': clearInput,
        }"
        [(ngModel)]="inputValue[0]"
        (ngModelChange)="temporalSaveData()"
      ></textarea>
    </ng-container>
    <!-- SIGNATURE -->
    <ng-container *ngIf="type === inputType.SIGNATURE">
      <div class="signature flex items-center justify-center gap-4 flex-col relative">
        <div
          (click)="showModalSign = true"
          class="signature-canvas w-full"
          [ngClass]="{
            'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500':
              control.invalid && submitting,
          }"
        >
          <img id="{{ forLabel }}" [src]="control.value" class="signature-canvas__img" />
        </div>
        <app-system-icon
          iconName="trash-bin"
          (click)="control.setValue('')"
          class="absolute right-2 top-2 text-red-500 cursor-pointer z-10"
          *ngIf="control.value !== ''"
        ></app-system-icon>
        <button
          (click)="showModalSign = true"
          type="button"
          systemButtonOutline
          class="signature-button w-full flex items-center justify-center gap-1"
          [ngClass]="{
            'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500':
              control.invalid && submitting,
          }"
        >
          <app-system-icon iconName="pen-nib" [iconSize]="18" class="signature-footer__icon"></app-system-icon>
          <span class="signature-footer__label">{{ label | titlecase }}</span>
        </button>
      </div>
      <!-- Signature modal -->
      <app-signature-modal
        [showModal]="showModalSign"
        (isModalOpen)="showModalSign = $event"
        (sendSignature)="setSignature($event)"
      ></app-signature-modal>
    </ng-container>
    <!-- INPUT SELECT -->
    <ng-container
      *ngIf="type === inputType.SELECT || type === inputType.RADIO"
      [ngTemplateOutlet]="dropdownSelect"
    ></ng-container>
    <!-- INPUT FILE -->
    <ng-container *ngIf="type === inputType.FILE" [ngTemplateOutlet]="fileInput"></ng-container>
    <!-- Suffix icon -->
    <app-system-icon
      [iconName]="suffix"
      class="form-group-input-icons__prefix"
      *ngIf="suffix && suffix !== ''"
    ></app-system-icon>
    <!-- Clear input button -->
    <img
      src="assets/img/ui-commons/close.svg"
      alt="Clear icon"
      class="form-group-input-icons__suffix form-group-input-icons__suffix--clear"
      (click)="control.setValue('')"
      *ngIf="clearInput && suffix === '' && control.value !== '' && !inputsShowClearOption.includes(type)"
    />
    <!-- Show password button -->
    <app-system-icon
      *ngIf="type === inputType.PASSWORD"
      [iconName]="showPassword ? 'eye-slash' : 'eye'"
      class="form-group-input-icons__suffix text-gray-400 dark:text-gray-400 cursor-pointer"
      (click)="showPassword = !showPassword"
      iconType="outline"
    ></app-system-icon>
    <!-- ERROR INPUT MESSAGES-->
    <small class="mt-2 text-sm text-red-600 dark:text-red-500" *ngIf="showTextError">
      <!-- Input required -->
      <ng-container *ngIf="control.errors?.required && (submitting || control.touched)">
        {{ 'HOME.REGISTER_PAGE.INPUT_REQUIRED' | translate }}
      </ng-container>
      <!-- Invalid pattern -->
      <ng-container
        *ngIf="
          !control.errors?.required &&
          (control.errors?.minlength || control.errors?.maxlength || control.errors?.pattern) &&
          (submitting || control.touched)
        "
      >
        {{
          errorMessages[forLabel] ?? errorMessages[format]
            | translate: { number: control.errors?.minlength?.requiredLength }
        }}
      </ng-container>
      <!-- Password does not match -->
      <ng-container
        *ngIf="
          !control.errors?.required &&
          !control.errors?.pattern &&
          !control.errors?.minLength &&
          !control.errors?.maxLength &&
          control.errors?.matchingControlValidator &&
          (submitting || control.touched)
        "
      >
        {{ 'HOME.REGISTER_PAGE.YOUR_PASSWORD_DOES_NOT_MATCH' | translate }}
      </ng-container>
    </small>
  </div>
</div>

<!-- SINGLE CHECKBOX -->
<div class="checkbox-container" *ngIf="control && type === inputType.CHECKBOX && selectOptions.length === 0">
  <input
    [formControl]="control"
    type="checkbox"
    systemCheckbox
    class="checkbox-container__checkbox"
    [ngClass]="{
      'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500 checkbox-container__checkbox--error':
        control.invalid && submitting,
    }"
    [(ngModel)]="inputValue[0]"
    (ngModelChange)="temporalSaveData()"
  />
  <span class="checkbox-text text-sm text-gray-500 font-[400]">
    {{ label | translate }}
    <a
      [routerLink]="link"
      systemLink
      linkType="primary"
      target="_blank"
      class="text-system-600 text-sm font-medium hover:underline checkbox-text__link"
      *ngIf="labelLink && labelLink !== ''"
    >
      {{ labelLink | translate }}
    </a>
    <span *ngIf="isRequired" class="checkbox-text__required-indicator">*</span>
  </span>
</div>

<!-- MULTIPLE CHECKBOX -->
<div class="form-group" *ngIf="control && type === inputType.CHECKBOX && selectOptions.length >= 1">
  <label systemLabel [for]="forLabel" class="form-group-label">
    {{ label | translate | titlecase }}
    <span *ngIf="isRequired" class="form-group-label__required-indicator">*</span>
  </label>
  <div class="checkbox-container" *ngFor="let option of selectOptions; let idx = index">
    <input
      type="checkbox"
      systemCheckbox
      class="checkbox-container__checkbox"
      [ngClass]="{
        'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500 checkbox-container__checkbox--error':
          control.invalid && submitting,
      }"
      [checked]="inputValue.includes(option.value)"
      (change)="setCheckboxValue($event, idx, option.value)"
    />
    <span class="accept-terms-text">
      {{ option.label | translate | titlecase }}
    </span>
  </div>
</div>

<!-- DROPDOWN SELECT -->
<ng-template #dropdownSelect>
  <button
    type="button"
    systemSelect
    class="form-group__input flex w-full p-2.5 justify-between items-center"
    [ngClass]="{
      'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500':
        (control.invalid && submitting) || (control.invalid && control.touched),
    }"
    [id]="'dropdownSearchButton_' + forLabel"
    data-dropdown-placement="bottom"
  >
    <span class="text-option-selected-dropdown">
      {{ (multipleChoiceLabel === '' ? 'DASHBOARD.FORM GENERATED.SELECT AN OPTION' : multipleChoiceLabel) | translate }}
    </span>
    <app-system-icon
      iconName="chevron-down"
      iconType="outline"
      class="h-5"
      *ngIf="control.value === '' || format === inputType.RADIO_MULTIPLE"
    ></app-system-icon>
    <img
      src="assets/img/ui-commons/close.svg"
      alt="Clear icon"
      class="form-group-input-icons__suffix form-group-input-icons__suffix--clear"
      (click)="control.setValue(''); inputValue[0] = ''; multipleChoiceLabel = ''; temporalSaveData()"
      *ngIf="clearInput && control.value !== '' && format !== inputType.RADIO_MULTIPLE"
    />
  </button>
  <div
    [id]="'dropdownSearch_' + forLabel"
    class="dropdown-container w-full z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
  >
    <div class="p-3">
      <label for="input-group-search" class="sr-only">Search</label>
      <div class="relative input-search" *ngIf="searchSelect">
        <div
          class="absolute inset-y-0 rtl:inset-r-0 start-0 flex items-center pl-2 pt-1 pointer-events-none input-search__icon"
        >
          <app-system-icon iconName="search" iconType="outline"></app-system-icon>
        </div>
        <input
          type="search"
          (input)="filterOptions($event)"
          id="input-group-search"
          class="block w-full p-2 pl-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-system-500 focus:border-system-500 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-system-500 dark:focus:border-system-500 input-search__input"
          [placeholder]="'DASHBOARD.WORK SPACE.SEARCH' | translate"
        />
      </div>
    </div>
    <ul class="py-2 text-sm text-gray-700 dark:text-gray-200 dropdown-list" aria-labelledby="dropdownSearchButton">
      @if (format === inputType.RADIO_MULTIPLE) {
        <li
          class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white dropdown-list__item"
          *ngFor="let option of selectOptions; let idx = index"
          [ngClass]="{ 'dropdown-list__item--selected': inputValue.includes(option.value) }"
        >
          <input
            type="checkbox"
            systemCheckbox
            class="checkbox-container__checkbox"
            [ngClass]="{
              'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500 checkbox-container__checkbox--error':
                control.invalid && submitting,
            }"
            [checked]="inputValue.includes(option.value)"
            (change)="setCheckboxValue($event, idx, option.value)"
          />
          {{ option.label }}
        </li>
      } @else {
        <li
          class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white dropdown-list__item"
          *ngFor="let option of selectOptions; let idx = index"
          (click)="
            control.setValue(option.value);
            inputValue[0] = option.value;
            multipleChoiceLabel = option.value;
            temporalSaveData()
          "
          [ngClass]="{ 'dropdown-list__item--selected': inputValue.includes(option.value) }"
        >
          {{ option.label }}
        </li>
      }
    </ul>
  </div>
</ng-template>

<!-- FILE INPUT -->
<ng-template #fileInput>
  <input
    #fileInputElement
    class="hidden"
    [id]="'getFile_' + forLabel"
    type="file"
    [required]="isRequired"
    [multiple]="isMultiple"
    (change)="onInputFileChange($event)"
  />
  <div
    (click)="triggerFileInputClick()"
    [ngClass]="{
      'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500':
        control.invalid && submitting,
      'input-disabled': control.disabled,
    }"
    class="flex text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 h-[42px]"
  >
    <div class="bg-system-400 space-indicator w-[130px] border h-full rounded-l-lg">
      <span>{{ (isMultiple ? 'DASHBOARD.ORDER.CHOOSE FILES' : 'DASHBOARD.ORDER.CHOOSE FILE') | translate }}</span>
    </div>
    <div class="flex items-center pl-4">
      <span>
        @if (control.value) {
          @if (isMultiple) {
            {{
              control.value.length +
                ' ' +
                ((control.value.length > 1 ? 'DASHBOARD.ORDER.FILES CHOSEN' : 'DASHBOARD.ORDER.FILE CHOSEN')
                  | translate)
            }}
          } @else {
            {{ control.value.name }}
          }
        } @else {
          {{ (isMultiple ? 'DASHBOARD.ORDER.NO FILES CHOSEN' : 'DASHBOARD.ORDER.NO FILE CHOSEN') | translate }}
        }
      </span>
    </div>
  </div>
</ng-template>
